export default "__VITE_ASSET__BC0Kdc6e__";